var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIconNf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 35,
    viewBox: "0 0 27 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8245 23.716C13.225 24.1168 13.8742 24.1166 14.2745 23.716L18.6676 19.3229C19.0682 18.9226 19.0682 18.2732 18.6676 17.8729C18.2673 17.4724 17.6182 17.4724 17.2176 17.8729L14.5749 20.5157V13.1064C14.5749 12.5401 14.1156 12.0811 13.5495 12.0811C12.9831 12.0811 12.5241 12.5401 12.5241 13.1064V20.5157L9.8813 17.8729C9.48076 17.4724 8.83161 17.4724 8.43107 17.8729C8.03079 18.2732 8.03079 18.9226 8.43107 19.3229L12.8245 23.716Z",
    fill: "#D59B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9428 26.3604H9.15625C8.59015 26.3604 8.13086 26.8194 8.13086 27.3857C8.13086 27.9518 8.59015 28.4111 9.15625 28.4111H17.9428C18.5089 28.4111 18.9682 27.9518 18.9682 27.3857C18.9682 26.8194 18.5092 26.3604 17.9428 26.3604Z",
    fill: "#D59B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4348 0H8.05849C7.78665 0 7.52576 0.108147 7.3335 0.300407L0.743767 6.89014C0.551506 7.08241 0.443359 7.34329 0.443359 7.61513V31.778C0.443359 33.5546 1.88879 35 3.66533 35H23.4348C25.2063 35 26.6568 33.5677 26.6568 31.778V3.22197C26.6568 1.4505 25.2247 0 23.4348 0ZM8.13139 2.40246V6.51684C8.13139 7.16278 7.60614 7.68803 6.9602 7.68803H2.84582L8.13139 2.40246ZM24.606 31.778C24.606 32.416 24.0904 32.9492 23.4348 32.9492H3.66533C3.01965 32.9492 2.49414 32.4237 2.49414 31.778V9.73907H6.9602C8.73674 9.73907 10.1822 8.29365 10.1822 6.51711V2.05078H23.4348C24.073 2.05078 24.606 2.56668 24.606 3.22197V31.778Z",
    fill: "#D59B00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconNf);
export default __webpack_public_path__ + "static/media/menu-icon-nf.ffc44418c64f9d66ed76ce18840e0f42.svg";
export { ForwardRef as ReactComponent };